document.addEventListener('DOMContentLoaded', () => {
  // Utilities
  // import('focus-visible').then((module) => module) // Not needed in this project
  // import('utility/page-restore').then((module) => module.default.init()) // Not needed, swup takes care of proper iOS back/forward navigation
  // import('utility/prefetch').then((module) => module.default.init()) // Not needed, swup takes care of prefetching
  // import('utility/smooth-scroll').then((module) => module.default.init()) // Has to be loaded in modules-loader
  import('utility/vertical-resize-check').then((module) => module.default.init())

  // Dev helpers
  if (process.env.NODE_ENV !== 'production') {
    import('helpers/dev-helpers').then((module) => {
      module.contentEditable.init()
      module.goToPage.init(['shift', 's'], '/styleguide')
      module.overlayGrid.init()
      module.toggleTheme.init()
    })
  }

  // Page loader with swup & modules loader
  import('helpers/page-loader').then((module) => module.default.init())

  // First page load
  document.body.classList.remove('noscript')

  // Remove preload class moved to the page loader to avoid first page load flicker
  // setTimeout(() => {
  //   document.body.classList.remove('preload')
  // }, 100)
})
